import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import navigationState from "./slices/stateSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    navigationState,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
